import React, { Component } from 'react';
import { APP_CONST } from '../../../../constants';
import { GeckoFields, toast } from '../../../../components';
import Commands, { MFA_SOFTWARE, VALID_MFA_METHODS } from './Commands';

// State Components
import Unconfigured from './components/Unconfigured';
import PhoneNumberRequired from './components/PhoneNumberRequired';
import ConfirmCode from './components/ConfirmCode';
import Manage from './components/Manage';

export const MODULE_STATE_UNCONFIGURED = 'unconfigured';
export const MODULE_STATE_PHONE_NUMBER_REQUIRED = 'phone_number_required';
export const MODULE_STATE_CONFIRM_CODE = 'confirm_code';
export const MODULE_STATE_MANAGE = 'manage';

export const QR_URL_BASE = 'https://api.geckoform.com/qr/';


export class ModuleTwoFactor extends Component {
    constructor(props) {
        super(props);

        this.state = {
            moduleState: MODULE_STATE_UNCONFIGURED,
        }

        this.getModuleState = this.getModuleState.bind(this);
        this.configureTfa = this.configureTfa.bind(this);
        this.updatePreferences = this.updatePreferences.bind(this);
        this.renderStateComponent = this.renderStateComponent.bind(this);
        this.confirmCode = this.confirmCode.bind(this);
        this.updatePhoneNumber = this.updatePhoneNumber.bind(this);
    }

    hasMfaConfigured(user) {
        if (user && user.provider && user.provider.UserMFASettingList) {
            return true;
        }

        return false;
    }

    getModuleState() {

        if (this.hasMfaConfigured(this.props.data.user)) {
            return MODULE_STATE_MANAGE;
        }

        if (this.state.secretCode) {
            if (this.hasPhoneNumber(this.props.data.user)) {
                return MODULE_STATE_CONFIRM_CODE;
            } else {
                return MODULE_STATE_PHONE_NUMBER_REQUIRED;
            }
        }

        return MODULE_STATE_UNCONFIGURED;
    }

    /**
     * Users MUST have a telephone number to set up Two Factor auth
     * 
     * @return bool
     */
    hasPhoneNumber(user) {
        if (user && user.provider && user.provider.phone_number) {
            return true;
        }

        return false;
    }    

    configureTfa() {
        this.props.setAlert(null);

        Commands.configureMfa().then((response) => {
            this.setState({
                b64Code: response.b64Code,
                secretCode: response.SecretCode,
            })
        });
    }

    confirmCode(code) {
        this.props.setAlert(null);

        if (!code || code.length < 6) {
            this.props.setAlert('Code must be 6 characters long');
            return Promise.reject();
        }

        return Commands.confirmMfa(code)
        .then(() => this.updatePreferences(false, true, MFA_SOFTWARE))
        .catch((err) => {
            this.props.setAlert(err.message);
        });
    }

    updatePhoneNumber(phoneNumber) {
        this.props.setAlert(null);

        return Commands.setPhoneNumber(phoneNumber)
        .then((response) => {
            this.props.iam();
        }).catch((err) => {
            this.props.setAlert(err.message);
        })
    }

    updatePreferences(sms, software, preferred) {
        this.props.setAlert(null);

        return Commands.mfaPreferences(sms, software, preferred)
        .then(() => {
            toast.success('Two-factor authentication preferences updated successfully.');
            if (this.props.iam) {
                this.props.iam();
            }
        })
        .catch((err) => {
            this.props.setAlert(err.message);
        });
    }

    renderStateComponent(moduleState) {
        switch(moduleState) {
            case MODULE_STATE_MANAGE:
                return (
                    <Manage 
                        preferences={this.props.data.user.provider.UserMFASettingList} 
                        default={this.props.data.user.provider.PreferredMfaSetting} 
                        updatePreferences={this.updatePreferences} 
                    />
                )

            case MODULE_STATE_CONFIRM_CODE:
                return <ConfirmCode qrUrl={QR_URL_BASE + this.state.b64Code} secretCode={this.state.secretCode} confirmCode={this.confirmCode}/>;

            case MODULE_STATE_PHONE_NUMBER_REQUIRED:
                return <PhoneNumberRequired submit={this.updatePhoneNumber} setAlert={this.props.setAlert}/>;

            case MODULE_STATE_UNCONFIGURED:
            default:
                return <Unconfigured onClick={this.configureTfa}/>;
        }
    }

    render() {
        return this.renderStateComponent(this.getModuleState());
    }
}

ModuleTwoFactor.defaultProps = {
    data: {},
    setAlert: () => null,
    iam: () => null,
}

export default ModuleTwoFactor;